import { BaseRecord } from "./BaseRecord";
import { PngIdentityRole } from "./pngIdentityRole";

export class PngIdentityUser extends BaseRecord<number> {
    public userName: string;
    public fullName: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public emailConfirmed: boolean;
    public phoneNumber: string;
    public phoneConfirmed: boolean;
    public passwordHash: string;
    public twoFactorEnabled: boolean;
    public roles: string[] = [];//PngIdentityRole[];
    public tenantId!: number;
    public parentTenantId!: number;
    public clientId!: number;
    public paymentTerms: string[] = [];

    constructor() {
        super();
        this.email = "";
        this.twoFactorEnabled = false;
        this.emailConfirmed = false;
        this.phoneNumber = "";
        this.phoneConfirmed = false;
        this.passwordHash = "";
        this.userName = "";
        this.firstName = "";
        this.lastName = "";
        this.fullName = "";
        this.roles = [];
        this.tenantId = 0;
        this.parentTenantId = 0;
        this.clientId = 0;
        this.paymentTerms = [];
    }
}
